module.exports = __webpack_public_path__ + "images/modules/how-it-works/1-reserve.svg";


//////////////////
// WEBPACK FOOTER
// ./images/modules/how-it-works/1-reserve.svg
// module id = 69
// module chunks = 0